var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UIKit",
    transform: "translate(-866.000000, -1162.000000)",
    fill: "#8298AB",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(530.000000, 750.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M344.333368,418.874994 L349.649018,424.190644 C349.783043,424.324711 349.783043,424.542575 349.649018,424.676601 L348.676601,425.649018 C348.542575,425.783043 348.324711,425.783043 348.190644,425.649018 L342.874994,420.333368 L337.558925,425.649018 C337.424858,425.783043 337.206993,425.783043 337.072926,425.649018 L336.10055,424.676601 C335.966483,424.542575 335.966483,424.324711 336.10055,424.190644 L341.41662,418.874994 L336.10055,413.558925 C335.966483,413.424858 335.966483,413.206993 336.10055,413.072926 L337.073387,412.10055 C337.207413,411.966483 337.425277,411.966483 337.559344,412.10055 L342.874994,417.41662 L348.190644,412.10097 C348.324711,411.966945 348.542575,411.966945 348.676601,412.10097 L349.649018,413.073387 C349.783043,413.207413 349.783043,413.425277 349.649018,413.559344 L344.333368,418.874994 Z",
    id: "\\uF00D"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.3f194687.svg";
export { ForwardRef as ReactComponent };